import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import ErrorBoundary from "./components/ErrorBoundary";
import Index from "./pages/Index";
import { usePageTracking } from "./hooks/usePageTracking";
// Removed pages -> permanent destinations (same list the prerender turns into redirect stubs).
import { redirects } from "../scripts/seo-routes.mjs";

const BlogIndex = lazy(() => import("./pages/BlogIndex"));
const BlogArticle = lazy(() => import("./pages/BlogArticle"));
const Services = lazy(() => import("./pages/Services"));
const ServiceDetail = lazy(() => import("./pages/ServiceDetail"));
const APropos = lazy(() => import("./pages/APropos"));
const Contact = lazy(() => import("./pages/Contact"));
const CommuneDetail = lazy(() => import("./pages/CommuneDetail"));
const MentionsLegales = lazy(() => import("./pages/MentionsLegales"));
const PolitiqueConfidentialite = lazy(() => import("./pages/PolitiqueConfidentialite"));
const PlanDuSite = lazy(() => import("./pages/PlanDuSite"));
const NotFound = lazy(() => import("./pages/NotFound"));
const GestionApp = lazy(() => import("./gestion/GestionApp"));
const OAuthConsent = lazy(() => import("./pages/OAuthConsent"));
const Avis = lazy(() => import("./pages/Avis"));
const AdminLeads = lazy(() => import("./pages/AdminLeads"));

function AppRoutes() {
  usePageTracking();

  return (
    <Routes>
      <Route path="/" element={<Index />} />
      {redirects.map((r: { from: string; to: string }) => (
        <Route key={r.from} path={r.from} element={<Navigate to={r.to} replace />} />
      ))}
      <Route path="/services" element={<Services />} />
      <Route path="/services/:slug" element={<ServiceDetail />} />
      <Route path="/a-propos" element={<APropos />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/carrosserie-carouge" element={<CommuneDetail slug="carouge" />} />
      <Route path="/carrosserie-vernier" element={<CommuneDetail slug="vernier" />} />
      <Route path="/carrosserie-meyrin" element={<CommuneDetail slug="meyrin" />} />
      <Route path="/carrosserie-lancy" element={<CommuneDetail slug="lancy" />} />
      <Route path="/blog" element={<BlogIndex />} />
      <Route path="/blog/:slug" element={<BlogArticle />} />
      <Route path="/mentions-legales" element={<MentionsLegales />} />
      <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
      <Route path="/plan-du-site" element={<PlanDuSite />} />
      <Route path="/avis" element={<Avis />} />
      <Route path="/admin/leads" element={<AdminLeads />} />
      <Route path="/gestion/*" element={<GestionApp />} />
      <Route path="/.lovable/oauth/consent" element={<OAuthConsent />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

const App = () => (
  <BrowserRouter>
    <ErrorBoundary>
      <Suspense fallback={<div className="min-h-screen bg-background" />}>
        <AppRoutes />
      </Suspense>
    </ErrorBoundary>
  </BrowserRouter>
);

export default App;
